export default __webpack_public_path__ + "b6927eef93e45bf04dda1ca938f13d00.png";